import { Globals } from '../../globals/variables';

// Se añaden los inputs para que la libreria DCL los capten y crear las etiquetas declarativas
export const addDeclarativeField = function (name, value) {
	const input = document.createElement('input');
	input.type = 'hidden';
	input.value = value;
	input.name = name;
	input.className = 'wg-input';
	return input;
};

// Funcion para buscar todos los form y añadir en cada uno los inputs(mirar funcion addLabelsWalmeric)
const waitForElementWalmeric = (selector) => {
	return new Promise((resolve) => {
		const elements = document.querySelectorAll(selector);

		if (document.querySelectorAll(selector)) {
			return resolve(elements);
		}
		const observer = new MutationObserver(() => {
			if (elements) {
				resolve(elements);
				observer.disconnect();
			}
		});
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
};

export const addLabelsWalmeric = async () => {
	let EDeclarativas = {
		verifyLeadId: 'NO',
		idVisitor: Piwik.getAsyncTracker().getVisitorId(),
	};

	const handleObj = {
		get: (target, prop) => {
			return target[prop];
		},
		set: (target, prop, value) => {
			try {
				const arrayPropiedades = Object.keys(target);
				if (!arrayPropiedades.includes(prop)) {
					throw new Error('Propiedad no existe en obj Datalead');
				}
				target[prop] = value;
			} catch (error) {
				console.error(error.message);
			}

			try {
				const newValue = value;
				if (!newValue) {
					throw new Error(
						'Esta intentado insertar un valor vacio en la propiedad ' +
							prop
					);
				}
				target[prop] = value;
			} catch (error) {
				console.error(error);
			}
		},
	};

	const dataLeadCallMeDeclarativas = new Proxy(EDeclarativas, handleObj);

	waitForElementWalmeric('.wg-form')
		.then((element) => {
			document.querySelectorAll('.wg-form').forEach((nodoElement) => {
				/*Refactorizalo en una funcion*/
				/*Declarativas*/
				Object.entries(EDeclarativas).forEach(([key, value]) => {
					let firstChild = nodoElement.firstChild;
					let field = addDeclarativeField(key, value);
					nodoElement.insertBefore(field, firstChild);
				});
			});
			globalThis.DCL.set.forms();
		})
		.catch((error) => {
			console.log(error);
		});

	return {
		Declarativas: dataLeadCallMeDeclarativas,
	};
};

/*Añade evento Submit */
export const eventAddLabels = () => {
	const btnSubmitWalmeric = document.querySelectorAll('.wg-submit');
	btnSubmitWalmeric.forEach((elem) => {
		elem.addEventListener('click', () => {
			addLabelsWalmeric();
		});
	});
};

// Modal de gracias para los formularios al aire
function modalGracias(formOnAir, response) {
	let padre = formOnAir.parentElement;
	formOnAir.style.display = 'none';

	if (response == 200) {
		padre.querySelector('#title').classList.add('hidden');
		padre.querySelector('#success').classList.remove('hidden');
	} else {
		padre.querySelector('#title').classList.add('hidden');
		padre.querySelector('#error').classList.remove('hidden');
	}
}

// Recoge el boton y el form mas cerca para despues recoger los datos(phone,politica privacidad). Con libreria DAL creamos el lead en Delio.
export const waitFormOnAir = async (formOnAir) => {
	let phoneInput;
	let dniInput;

	if (formOnAir) {
		phoneInput = formOnAir.querySelector('input[name="phone"]');
		dniInput = formOnAir.querySelector('input[name="observation"]');
	}

	const phoneValue = phoneInput ? phoneInput.value : '';
	const dniValue = dniInput ? dniInput.value : '';

	let objectFormOnAir = {
		phone: phoneValue,
		dni: dniValue,
	};

	if (objectFormOnAir.phone != '' && objectFormOnAir.dni != '') {
		return new Promise((resolve, reject) => {
			DAL.Ajax({
				type: 'jsonp',
				url: 'https://ws.walmeric.com/provision/wsclient/client_addlead_ws.html?',
				data: {
					phone: objectFormOnAir.phone,
					dni: objectFormOnAir.dni,
					idVisitor: Piwik.getAsyncTracker().getVisitorId(),
					idTag: Globals.idTag,
					verifyLeadId: 'NO',
				},
			})
				.done(function (response) {
					resolve(response.leadId);
					// Modal de gracias
					modalGracias(formOnAir, response.code);
				})
				.fail(function (response) {
					modalGracias(formOnAir, response.code);
					reject(new Error('Fallo en enviar el lead'));
				});
		});
	} else {
		sendFormOnAir('.wg-form_api');
	}
};

// Mapa para almacenar event listeners
const formListeners = new WeakMap();

function addFormListener(form) {
	if (!formListeners.has(form)) {
		const listener = (event) => {
			event.preventDefault();
			waitFormOnAir(form);
			// Eliminar event listener después de usarlo una vez
			removeFormListener(form);
		};
		form.addEventListener('submit', listener, { once: true });
		// Almacenar referencia al event listener
		formListeners.set(form, listener);
	}
}

// Función para eliminar el event listener del formulario
function removeFormListener(form) {
	if (formListeners.has(form)) {
		const listener = formListeners.get(form);
		form.removeEventListener('submit', listener);
		formListeners.delete(form);
	}
}

// Observamos cualquier cambio en el body para poder captar cuando se crea el formulario al vuelo.
export const sendFormOnAir = async (selector) => {
	const observer = new MutationObserver((observer) => {
		const formOnAir = document.querySelector(selector);
		if (formOnAir != null) {
			addFormListener(formOnAir);
		}
	});

	// Función para conectar el observer al formulario
	const idPortal = document.querySelector('#headlessui-portal-root');
	if(idPortal){
		observer.observe(idPortal, {
			childList: true,
			subtree: true,
		});
	}

	// Desconectar el observer después de 30 minutos
	setTimeout(() => {
		observer.disconnect();
	}, 30 * 60 * 1000);
};
